var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFormatBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-3h24v24H-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.54 8.308c2.047-1.826 2.138-4.871.201-6.802C11.775.542 10.43-.003 9.023 0H1.182C.805 0 .5.288.5.643v.643c0 .355.305.643.682.643h.682V16.07h-.682c-.377 0-.682.288-.682.643v.643c0 .355.305.643.682.643h8.863c3.013 0 5.455-2.303 5.455-5.143 0-1.988-1.21-3.693-2.96-4.549zm-7.95-6.38h3.75c1.695 0 3.07 1.296 3.07 2.893 0 1.598-1.375 2.893-3.07 2.893H4.59V1.93zm4.774 14.143H4.59V9.643h4.773c1.882 0 3.409 1.439 3.409 3.214s-1.527 3.214-3.41 3.214z",
    fill: "#151A30"
  }))));
}

export default SvgFormatBold;